/**
 * Utilidades de formateo para la aplicación financiera
 */

/**
 * Formatea un número como moneda mexicana
 * @param {number|string} v - Valor a formatear
 * @returns {string} - Valor formateado como $X,XXX.XX
 */
export const money = (v) =>
  Number(v || 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  });

/**
 * Formatea un número como moneda con 4 decimales (para tarifas)
 * @param {number|string} v - Valor a formatear
 * @returns {string} - Valor formateado como $X,XXX.XXXX
 */
export const money4 = (v) =>
  Number(v ?? 0).toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 4,
  });

/**
 * Obtiene la fecha de corte (ayer) en formato dd-MM-yyyy
 * @returns {string} - Fecha formateada
 */
export function getFechaCorteAnterior() {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}
